import { IdCountryCode } from "./IdCountryCode";
import { IdLang } from "./IdLang";
export var languageByCountryCode = new Map([
    [IdCountryCode.Argentina, IdLang.Spanish],
    [IdCountryCode.Australia, IdLang.English],
    [IdCountryCode.Bulgary, IdLang.Bulgarian],
    [IdCountryCode.Brasil, IdLang.BrazilianPortuguese],
    [IdCountryCode.CzechRepublic, IdLang.Czech],
    [IdCountryCode.Germany, IdLang.German],
    [IdCountryCode.Danmark, IdLang.Danish],
    [IdCountryCode.Spain, IdLang.Spanish],
    [IdCountryCode.Finland, IdLang.Finnish],
    [IdCountryCode.France, IdLang.French],
    [IdCountryCode.UnitedKingdom, IdLang.English],
    [IdCountryCode.Greece, IdLang.Greek],
    [IdCountryCode.Hungary, IdLang.Hungarian],
    [IdCountryCode.Italy, IdLang.Italian],
    [IdCountryCode.Japan, IdLang.Japanese],
    [IdCountryCode.Lithuania, IdLang.Lithuanian],
    [IdCountryCode.Mexico, IdLang.Spanish],
    [IdCountryCode.Netherlands, IdLang.Dutch],
    [IdCountryCode.Norway, IdLang.Norwegian],
    [IdCountryCode.Poland, IdLang.Polish],
    [IdCountryCode.International, IdLang.English],
    [IdCountryCode.Portugal, IdLang.BrazilianPortuguese],
    [IdCountryCode.Romania, IdLang.Romanian],
    [IdCountryCode.Russia, IdLang.Russian],
    [IdCountryCode.Sweden, IdLang.Swedish],
    [IdCountryCode.Slovenia, IdLang.Slovak],
    [IdCountryCode.Turkey, IdLang.Turkish],
    [IdCountryCode.UnitedStates, IdLang.English],
]);



//////////////////
// WEBPACK FOOTER
// ./src/utils/i18n/languageByCountryCode.ts
// module id = 1120
// module chunks = 3